<template>
  <div id="app">

    <transition name="fade" mode="out-in">
    <router-view />
    </transition>
    <Header :key="$route.fullPath" v-if="!$route.path.includes('/admin')"/>

  </div>
</template>
<script>

import Header from './components/Header.vue'

export default {
  name: 'app',
  data () {
    return {
      headerColor: "rgba(0, 0, 0, 0.2)"
    }
  },
  components: {
    Header
  },
  methods: {

  }
}

</script>

<style>

@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro');
@import url('https://fonts.googleapis.com/css?family=Roboto+Slab&display=swap');

a {
  font-style: unset;
  color: unset;
/* text-decoration: unset; */
}
::selection {
  background: #3b9549; /* WebKit/Blink Browsers */
  color: #fff;
}
::-moz-selection {
  background: #3b9549; /* Gecko Browsers */
  color: #fff;
}

html,body {
  margin: 0;
  padding: 0;
  /* background-color: #000; */
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.info {
  width: 90%;
  max-width: 900px;
  margin: 1em auto;
  text-align: left;
  padding: 5px;
}

.info h3 {
  letter-spacing: 1px;
  font-size: 2em;
  font-family: 'Roboto Slab', 'Avenir', sans-serif;
}
.info p {
  font-family: 'avenir', sans-serif;
  letter-spacing: 1px;
  font-size: 1em;
  max-width: 90%;
}
.info h4 {
  max-width: 500px;
}
.info p {
  font-family: 'avenir', sans-serif;
  letter-spacing: 1px;
  font-size: 1.1em;

  /* border-left: 4px solid #333; */
  /* padding-left: 1em; */
}

.info a {
  /* text-decoration: none; */
  color: inherit;
  font-weight: bold;
}

.info ul {
  margin: 0;
  padding-left: 20px;
  line-height: 2em;
  font-size: 1.2em;
}


#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #222;
  margin-top: 0;
  width: 100%;
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.1s;
  transition-property: opacity;
  transition-timing-function: ease-in-out;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

@keyframes animate {
  0% {
    width: 100%;
  }
  50% {
    width: 50%;
  }
  100% {
    width: 100%;
  }
}
  .hide-desktop {
    display: none !important;

  }
  .hide-mobile {
    display: block;
  }

@media only screen and (max-width: 900px) {
  .info {
    width: 90%;
    max-width: 90%;
    margin: 0 auto;
  }
  .info p {
    max-width: 100%;
  }
  .hide-desktop {
    display: block !important;
  }
  .hide-mobile {
    display: none !important;
  }
}


</style>

  


